export default __webpack_public_path__ + "static/media/Captain's Helm of Heaven's Pass.d3e2351c.jpg";